import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Typography,
} from "@/components/ui";

export function WelcomeStep() {
  return (
    <div className="space-y-6">
      <Card className="bg-muted/40 border-border rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Getting started</CardTitle>
          <Typography className="text-muted-foreground text-sm">
            All steps are optional, and we’ve already done some of the heavy
            lifting by setting up sensible defaults.
          </Typography>
        </CardHeader>
        <CardContent>
          <Typography
            tag="p"
            className="text-muted-foreground text-sm leading-6 sm:text-base"
          >
            LawWorks brings your matters, tasks, deadlines, and client
            communications into one place. This wizard helps you set up the
            basics so the app matches your firm. Keep the defaults, or add,
            edit, and remove anything as you go.
          </Typography>
        </CardContent>
      </Card>

      <div className="grid gap-4 lg:grid-cols-3">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">Personalize your space</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Typography className="text-muted-foreground text-sm">
              Add profile photos and your firm logo to make LawWorks feel like
              home.
            </Typography>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary">Profile photo</Badge>
              <Badge variant="secondary">Firm logo</Badge>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">Shape your workflow</CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Typography className="text-muted-foreground text-sm">
              Define the defaults that power your matters to drive team
              efficiency.
            </Typography>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary">Statuses</Badge>
              <Badge variant="secondary">Types</Badge>
              <Badge variant="secondary">Costs</Badge>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-base">
              Automate repeatable tasks
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <Typography className="text-muted-foreground text-sm">
              Build task plans to trigger the right work at the right time.
            </Typography>
            <div className="flex flex-wrap items-center gap-2">
              <Badge variant="secondary">Task plans</Badge>
              <Badge variant="secondary">Triggers</Badge>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
